import { amplifyClient, axios, getEndpointV2 } from 'api';
import { call, select } from 'redux-saga/effects';
import { userFetch } from 'store/features/userFetch';
import { UserData } from 'types';

export function* uploadCompanyFile({ file }: { file: File }): Generator<unknown, string> {
  const { companyId } = (yield select(userFetch.selectors.getData)) as UserData;

  const ext = file.name.split('.')?.[1];

  const { key, url } = (yield call(amplifyClient, {
    method: 'get',
    url: getEndpointV2({
      path: '/auth/company/:companyId/signedUrl',
      urlParams: { companyId },
      params: { ext, configType: 'DATA' },
    }),
  })) as { key: string; url: string };

  yield call(axios, {
    method: 'put',
    url,
    data: file,
  });

  return key;
}
